import type { MaskitoOptions } from '@maskito/core';

export const ZIP_CODE_PLACEHOLDER = 'XXXXX';

export const MIN_ZIP_LENGTH = 5;

export const ZIP_MASK_OPTIONS = {
  mask: /^\d{0,5}$/,
} satisfies MaskitoOptions;
